import React, { useState } from 'react';

import MultiSelect from 'src/components/MultiSelect';
import { Location } from 'src/types';

interface NavbarLocationSelectProps {
  options: Location[];
  onAccept: (value: Location[]) => void;
}

const NavbarLocationSelect: React.FC<NavbarLocationSelectProps> = ({ options, onAccept }) => {
  const [tempLocations, setTempLocations] = useState<Location[]>(
    options.length > 0 ? [options[0]] : []
  ); // Local state

  if (options.length === 0) {
    console.warn('No locations found. Please add a location to the database.');
    return null;
  }

  return (
    <MultiSelect
      label="Selected Location(s)"
      placeholder="Find location"
      getOptionLabel={(option) => option.name}
      options={options}
      value={tempLocations}
      onChange={(value) => {
        setTempLocations(value);
      }}
      onAccept={(locations) => {
        onAccept(locations);
      }}
    />
  );
};

export default NavbarLocationSelect;
